import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";

interface StarsReviewsProps {
  stars: number;
  reviewsCount?: string;
  isMobile?: boolean;
}

export const StarsReviews: React.FC<StarsReviewsProps> = ({
  stars,
  reviewsCount,
  isMobile,
}) => {
  const fullStars = Math.floor(stars);
  const decimal = stars - fullStars;
  const fillPercent = Math.round(decimal * 100);

  return (
    <div
      className="stars-reviews-container"
      style={{
        alignItems: isMobile ? "center" : "flex-start",
      }}
    >
      <div className="stars">
        {Array.from({ length: fullStars }, (_, index) => (
          <FontAwesomeIcon
            key={index}
            icon={faStar}
            fontSize={16}
            color="#EEB804"
          />
        ))}
        {stars % 1 !== 0 && (
          <FontAwesomeIcon
            icon={faStar}
            fontSize={16}
            color="#EEB804"
            style={{
              clipPath: `inset(0 ${100 - fillPercent}% 0 0)`,
            }}
          />
        )}
      </div>
      <div className="reviews-count">
        {stars} Stars (+{reviewsCount ?? "29k"} Reviews)
      </div>
    </div>
  );
};
